export enum LocalStorageEnum {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  USER = 'USER',
}
